export default __webpack_public_path__ + "static/media/card-mandiri.fb9108c1.webp";